import { Injectable } from '@angular/core';
import { ToastNotificationService } from './toast-notification/toast-notification.service';
import { Browser } from '@capacitor/browser';
import { EFEKTIKA_PDF } from '../shared/constants';
import { ToastNotificationComponent } from '../shared/toast-notification/toast-notification.component';
import { NativeCheckService } from './native-check.service';

// todo - pdf/file download implementation is duplicit across multiple usages, clean them to single service
@Injectable({
  providedIn: 'root'
})
export class EfektikaPdfDownloadService {
  public constructor(
    private toastService: ToastNotificationService,
    private nativeCheckService: NativeCheckService,
  ) {}

  public downloadEfektikaPdf(): void {
    const efektikaUrl = `assets/documents/${EFEKTIKA_PDF}.pdf?t=${Date.now()}`;
    if(this.nativeCheckService.isNativePlatform()) {
      // FIXME - source of static documents should be from /src/assets/documents, not hardcoded production (2)
      Browser.open({ url: 'https://bwm.bcas.cz/' + efektikaUrl });
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', efektikaUrl, true);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');

          // cleanup
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 25000);
        } else {
          this.toastService.addNotification({
            title: 'toastNotifications.headers.error',
            message: 'toastNotifications.messages.documentError',
            type: 'warning',
            component: ToastNotificationComponent
          });
        }
      };

      xhr.send();
    }
  }
}
